import script from "./QuickformTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickformTabs.vue?vue&type=script&lang=ts&setup=true"

import "./QuickformTabs.vue?vue&type=style&index=0&id=65de1e86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65de1e86"]])

export default __exports__